import { useState, useEffect } from 'react'
import http from 'http'
import { useProfile } from 'context/Profile'

const PathImage = ( {
  identity
} ) => {
  const profile = useProfile()
  const [ image, setImage ] = useState()

  useEffect( () => {
    if ( image )
      return

    http( {
      method: 'GET',
      url: '/render/route',
      params: {
        _id: identity,
        __background_color: 'transparent',
        __point_color: profile.themeParams[ 'accent_text_color' ]
      }
    } )
      .then( ( { data } ) => {
        setImage( data )
      } )
  } )

  if ( ! image )
    return null
 
  return <div className="path-container" dangerouslySetInnerHTML={ { __html: image } } />
}

export default PathImage
